import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DialogService } from '../../_services/dialog.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { itLocale } from 'ngx-bootstrap/locale';

@Component({
    selector: 'app-my-datepicker',
    template: `
    <input
        type="text"
        class="form-control"
        style="margin-bottom:10px;"
        #dp="bsDatepicker"
        bsDatepicker
        [bsConfig]="bsConfig"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [(ngModel)]="dateModel"
        (ngModelChange)="inputChanged($event)"/>
    `
})
export class MyDatepickerComponent implements OnInit {

    constructor(
        private _dialog: DialogService,
        private _bsLocale: BsLocaleService
    ) {
        const myItLocale = Object.assign({}, itLocale, {
            week: {
                dow: 3,
                doy: 4
            },
            invalidDate: 'Data non valida'
        });
        defineLocale('my-it', myItLocale);
        this._bsLocale.use('my-it');
    }

    @Input() disabled = false;
    @Input() placeholder = 'Inserisci data';

    bsConfig: Partial<BsDatepickerConfig> = {
        adaptivePosition: true,
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        customTodayClass: 'datepicker-today-highlight',
        selectFromOtherMonth: true
    };

    @Input() dateModel: Date;
    @Output() dateModelChange: EventEmitter<Date> = new EventEmitter<Date>();

    lastValidDate: Date;

    ngOnInit () {
        if (this.dateModel && !isNaN(this.dateModel.getTime())) {
            this.lastValidDate = new Date(this.dateModel);
        } else {
            this.lastValidDate = new Date();
        }
    }

    inputChanged(date) {
        let error = false;

        if (date && !isNaN(date.getTime())) {
            const dateYear = date.getFullYear();
            const currYear = new Date().getFullYear();

            if (dateYear > currYear + 9) {
                this._dialog.warningAlert('Attenzione', 'La data inserita fa riferimento al ' + dateYear);
            }

            if (dateYear < 1000) {
                error = true;
            }
        } else {
            error = true;
        }

        if (error) {
            this._dialog.invalidDateAlert();
            this.dateModel = new Date(this.lastValidDate);
        } else {
            this.lastValidDate = new Date(date);
        }

        this.dateModelChange.emit(this.dateModel);
    }
}
